module.exports = __webpack_public_path__ + "img/11.e894a6c3.png";